const secrets = {
    third_party_token_set: {
        token_not_found: 'Nie znaleziono rekordu tokena.',
        access_token_expired: 'Token dostępu wygasł. Proszę ponownie połączyć swoje konto.',
    },
};
export default Object.freeze(secrets);
